import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LineChart,
  Line,
} from "recharts";
import { Loader2 } from "lucide-react";
import RecentActivity from "./recent.activity";

export default function DashboardTwoCharts({ analytics, isLoading }) {
  const registrationsTrend = analytics?.registrationsTrend ?? [];
  const topOrganizations = analytics?.topOrganizations ?? [];

  return (
    <div className="mt-8">
      <div className="flex flex-col lg:flex-row gap-6">
        {/* User Growth Line Chart */}
        <div className="bg-white shadow rounded-xl p-5 flex-1">
          <h2 className="font-popinsSemiBold text-base text-[#1E1B39] mb-1">
            User Growth Over Time
          </h2>
          <p className="font-popinsRegular text-xs text-black/40 mb-4">
            New registrations — past 6 months
          </p>
          {isLoading ? (
            <div className="h-52 flex items-center justify-center">
              <Loader2 className="animate-spin text-[#3FC4E3]" size={24} />
            </div>
          ) : (
            <div className="h-52">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={registrationsTrend}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                  <Tooltip formatter={(val) => [val, "Registrations"]} />
                  <Line
                    type="monotone"
                    dataKey="count"
                    stroke="#0EA5E9"
                    strokeWidth={3}
                    dot={{ r: 4, fill: "#0EA5E9" }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>

        {/* Top 5 Active Organizations Bar Chart */}
        <div className="bg-white shadow rounded-xl p-5 flex-1">
          <h2 className="font-popinsSemiBold text-base text-[#1E1B39] mb-1">
            Top 5 Active Organizations
          </h2>
          <p className="font-popinsRegular text-xs text-black/40 mb-4">
            By total events created
          </p>
          {isLoading ? (
            <div className="h-52 flex items-center justify-center">
              <Loader2 className="animate-spin text-[#3FC4E3]" size={24} />
            </div>
          ) : topOrganizations.length === 0 ? (
            <div className="h-52 flex items-center justify-center">
              <p className="text-black/30 font-popinsRegular text-sm">No data yet</p>
            </div>
          ) : (
            <div className="h-52">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={topOrganizations}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 11 }}
                    interval={0}
                    tickFormatter={(v) => v.length > 8 ? v.slice(0, 8) + "…" : v}
                  />
                  <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                  <Tooltip formatter={(val) => [val, "Events"]} />
                  <Bar dataKey="events" barSize={30} radius={[5, 5, 0, 0]}>
                    {topOrganizations.map((_, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={index === 0 ? "#0077B6" : "#e5e7eb"}
                      />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      </div>

      {/* Recent Activity */}
      <div className="mt-6">
        <RecentActivity recentActivity={analytics?.recentActivity} />
      </div>
    </div>
  );
}
